import { render, staticRenderFns } from "./CustomRow.vue?vue&type=template&id=c7060e2a&scoped=true&"
import script from "./CustomRow.vue?vue&type=script&lang=js&"
export * from "./CustomRow.vue?vue&type=script&lang=js&"
import style0 from "./CustomRow.vue?vue&type=style&index=0&id=c7060e2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7060e2a",
  null
  
)

export default component.exports